import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TodoComponent } from '../../../common/widgets/todo/todo.component';
import { EventCalendarComponent } from '../../../common/event-calendar/event-calendar.component';

@Component({
  selector: 'app-hra-content',
  imports: [CommonModule, TodoComponent, EventCalendarComponent],
  templateUrl: './hra-content.component.html',
  styleUrl: './hra-content.component.scss',
})
export class HraContentComponent {
  @Input() user: any;

}
